module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jc7MQ"))).then(() => parcelRequire('dJXJK'));